<mat-card
    class="daxa-card active-courses-card mb-25 border-radius bg-white border-none d-block"
    [class.component-dark-theme]="themeService.isDark()"
>
    <mat-card-content>
        <mat-card-header>
            <mat-card-title>
                <div class="savings-title">
                    <span>{{ 'pie_dashboard.savings.kicker' | translate }}</span>
                    <h5 class="mb-0">
                        {{ 'Savings' | translate }}
                    </h5>
                </div>
            </mat-card-title>
        </mat-card-header>

        <div class="savings-orb">
            <span class="savings-orb__ring"></span>
            <div class="icon text-center rounded-circle text-white position-relative mx-auto">
                <i class="material-symbols-outlined">savings</i>
            </div>
        </div>

        <div class="savings-total">
            <span>{{ 'pie_dashboard.savings.estimated_tariff_saving' | translate }}</span>
            <strong>{{ 0 | cultural }} {{ 'DKK' | translate }}</strong>
        </div>

        <div class="info d-flex align-items-center justify-content-between">
            <div class="sub-section text-start">
                <span class="sub-title d-block text-body fw-medium">{{ 'Today' | translate }}</span>
                <div class="number fw-medium lh-1">{{ 0 | cultural }} {{ 'DKK' | translate }}</div>
            </div>
            <div class="sub-section text-end">
                <span class="sub-title d-block text-body fw-medium">{{ 'This_Year' | translate }}</span>
                <div class="number fw-medium lh-1">{{ 0 | cultural }} {{ 'DKK' | translate }}</div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
